'use strict';

module Patersons {

    export interface ReportScope extends ng.IScope {
        accounts: Array<Account>;
        selectedAccount: Account;
        report: AbstractReport;
        hasAccoladeAccounts: boolean;
        currentPage: string;

        loaded: boolean;

        reportType: string;
        startDate: Date;
        endDate: Date;
        reportStartDate: Date;
        isError: boolean;
        hasData: boolean;

        searchtextRun: string;
        searchtext: any;
        isDownloadReady: boolean;
        isDownloading: boolean;
        isRendering: boolean;
        events: ReportViewCtrl;

        isPreselected: boolean;
        initialReportGenerated: boolean;
        collapsedBanner: boolean;
        showNewReportBtn: boolean;

        hidePdf: boolean;
        hideCsv: boolean;

        valuationReport: ValuationStatement;
        userCompany: UserCompany;
    }
    
    
    //export class ReportViewCtrl extends AbstractController {
    export class ReportViewCtrl extends PortfolioBaseCtrl {
        q: ng.IQService;
        scope: Patersons.ReportScope;
        portfolioService: Patersons.PortfolioService;
        reportService: Patersons.ReportService;
        reportDownloadService: Patersons.ReportDownloadService;
        bulkDownloadService: Patersons.BulkDownloadService;
        static $inject = ['$q', '$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService', 'reportService', 'reportDownloadService', 'bulkDownloadService','navigationService', 'userCompanyService'];

        constructor($q, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, portfolioService, reportService, reportDownloadService, bulkDownloadService, navigationService, userCompanyService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.q = $q;
            this.scope = $scope;
            this.scope.events = this;
            this.portfolioService = portfolioService;
            this.reportService = reportService;
            this.reportDownloadService = reportDownloadService;
            this.bulkDownloadService = bulkDownloadService;
            this.scope.loaded = null;
            this.scope.accounts = new Array<Account>();
            this.scope.currentPage = this.state.current.name;
            this.scope.endDate = moment().toDate();
            this.scope.startDate = moment().subtract(1, 'year').toDate();

            this.scope.showNewReportBtn = true;
            this.scope.isError = false;
            this.scope.hasData = false;
            this.scope.searchtextRun = "Run another report";
            this.scope.searchtext = {
                open: "Run another report",
                close: "Hide report form"
            };
            this.scope.isPreselected = false;
            this.scope.collapsedBanner = false;
            if($stateParams.hasAccoladeAccounts){
                this.scope.hasAccoladeAccounts = $stateParams.hasAccoladeAccounts;
            }else{
                this.scope.hasAccoladeAccounts = null;
            }

            if ($stateParams.collapsedBanner == true){
                this.scope.collapsedBanner = true;
                this.scope.loaded = true;
            }

            if (this.state.current.name == "report.tax"){
                this.scope.isPreselected = true;
                this.scope.reportType = "TaxReports";
            }else if (this.state.current.name == "report.quarterly") {
                this.scope.isPreselected = true;
                this.scope.reportType = "QuarterlyReports";
            }else if (this.state.current.name == "report.invoices") {
                this.scope.isPreselected = true;
                this.scope.reportType = "InvoiceReports"
            }
            if(this.scope.isPreselected){
                this.scope.loaded = true;
                this.scope.collapsedBanner = true;
                this.scope.searchtextRun = "Run another search";
                this.scope.searchtext = {
                    open: "Run another search",
                    close: "Hide search form"
                };
            }
            this.scope.hideCsv = false;
            this.scope.hidePdf = false;
            if (!this.scope.loaded) {
                this.scope.loaded = false;
            }

            userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company;
              })

            this.load();
        }

        load() {
            this.portfolioService.getCombinedPortfolioData()
                .then((result) => {
                    this.scope.loaded = true;
                    this.scope.$apply(() => {
                        this.scope.accounts = result.filter(r => r.accountType == "Accolade");
                        this.scope.hasAccoladeAccounts = this.scope.accounts.some(a => a.isAccolade);
                        if (this.scope.isPreselected && !this.scope.hasAccoladeAccounts){
                            this.scope.collapsedBanner = false;
                            this.state.go('report')
                        }
                    });
                });
        };

        setSelectedAccount(accountId: string) {
            this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];
            console.info('selected account id: ' + this.scope.selectedAccount.accountId);
            this.scope.isError = false;
            console.log(this.scope.selectedAccount)
            this.scope.hasData = false;
        }
        toggleNewReportBtn(){
            this.scope.showNewReportBtn = !this.scope.showNewReportBtn;
        }
        setFromDate(fromDate: Date) {
            this.scope.startDate = fromDate;
            console.info('from date: ' + this.scope.startDate);
        }

        setToDate(toDate: Date) {
            this.scope.endDate = toDate;
            console.info('to date: ' + this.scope.endDate);
        }

        setReportType(reportType: string) {
            this.scope.reportType = reportType;
            console.info('report types: ' + this.scope.reportType);
            this.scope.isError = false;
            this.scope.hasData = false;
        }

        get showFromDate() {
            if(this.scope.reportType === ReportType.UnrealisedCapitalGains.toString()){
                return false;
            }else if(this.scope.reportType === ReportType.Valuation.toString()){
                return false;
            }else{
                return true;
            }
        }

        get toDateLabel() {
            return this.showFromDate ? 'To:' : 'As at:';
        }

        get dateRangeLabel() {
            if (this.showFromDate) {
                let fromDateString: string = moment(this.scope.report.dateFrom).format('D MMM YYYY');
                let toDateString: string = moment(this.scope.report.dateTo).format('D MMM YYYY');
                return `From ${fromDateString} to ${toDateString}`;
            } else {
                let asAtDateString: string = moment(this.scope.report.asAtDate).format('D MMM YYYY');
                return `As at: ${asAtDateString}`;
            }
        }

        get areReportComponentsVisible() {
            return this.scope.report != null && this.scope.report.reportType.toString() == this.scope.reportType;
        }

        renderReport = function () {
            this.scope.isRendering = true;
            this.scope.isDownloadReady = false;
            this.scope.isError = false;
            this.scope.hasData = false;
            this.scope.initialReportGenerated = true;
            this.scope.showNewReportBtn = true;
            if (this.scope.reportType === "TaxReports" || this.scope.reportType === "QuarterlyReports" || this.scope.reportType === "InvoiceReports"){
              this.scope.hidePdf = true;
              this.scope.hideCsv = true;
            }
            else
            {
              this.scope.hidePdf = false;
              this.scope.hideCsv = false;
            }

            this.reportService.getReport(this.scope.reportType, this.scope.selectedAccount.accountId, this.scope.startDate, this.scope.endDate)
                .then((result) => {
                    this.scope.report = result;
                    this.scope.generatedDateTime = moment.tz(this.scope.report.creationDateUtc, 'Australia/Sydney').format('h:mm a');
                    this.scope.generatedDate = moment(this.scope.report.creationDateUtc).tz('Australia/Sydney').toDate();
                    this.scope.isDownloadReady = true;
                    this.scope.isError = false;
                    this.scope.hasData = true;
                },
                (reason) => {
                  this.scope.isError = true;
                  this.scope.hasData = false;
                })
                .finally(() => {
                    this.scope.reportStartDate = this.scope.startDate;
                    this.scope.reportEndDate = this.scope.endDate;
                    this.scope.isRendering = false;
                });
        };

        downloadPdf() {
            console.info('Download PDF');
            this.reportDownloadService.downloadPdfFile(this.scope.report, this.scope.selectedAccount);
        }

        downloadCsv() {
            console.info('Download CSV');
            this.reportDownloadService.downloadCsvFile(this.scope.report, this.scope.selectedAccount);
        }

        downloadInvestorDocuments(investorDocs) {
            if (investorDocs.length <= 0) {
                return;
            }

            this.scope.isDownloading = true;
            var filename = this.scope.selectedAccount.accountId + "-" + moment(new Date()).format("YYYY-MM-DD") + ".zip";
            this.bulkDownloadService.downloadItems(investorDocs, filename)
                .finally(() => {
                    this.scope.isDownloading = false;
                });
        }
    }
}
